<div class="page-container">
  <div class="card p-3 m-3 position-relative">
    <!-- Bottone toggle in alto a destra -->
    <button
      type="button"
      class="position-absolute"
      style="
        top: 10px;
        right: 10px;
        border: none;
        background: none;
        padding: 0;
        margin: 0;
        line-height: 1;
      "
      (click)="showFilters = !showFilters"
      [title]="showFilters ? 'Nascondi filtri' : 'Mostra filtri'"
    >
      <i
        class="bi"
        [ngClass]="showFilters ? 'bi-chevron-up' : 'bi-chevron-down'"
        style="font-size: 1.4rem; padding: 5px"
      ></i>
    </button>

    <div class="row px-3 mb-2">
      <div class="mb-2 d-flex align-items-center gap-3">
        <h2 class="mb-0"><b>Elenco Colli</b></h2>

        <!-- Totale colli -->
        <div
          class="total-parcels"
          title="Totale colli che corrispondono ai filtri"
        >
          <i class="bi bi-box-seam total-parcels-icon"></i>
          <span class="total-parcels-value">
            <span
              *ngIf="isLoadingParcels"
              class="spinner-border spinner-border-sm"
            ></span>
            <ng-container *ngIf="!isLoadingParcels">
              {{ searchCompleted ? (totalRecords | number) : "–" }}
            </ng-container>
          </span>
        </div>
        <span
          class="status-indicator-undefined"
          *ngIf="
            !shouldHideBigOrdersToggle() && canWithGeofencingTourBigOrder()
          "
        >
          <div class="custom-switch-btn d-flex align-items-center">
            <label
              class="form-check-label me-2"
              for="showBigOrders"
              style="cursor: pointer"
            >
              Visualizza anche Big Orders
            </label>
            <div class="form-check form-switch m-0" style="cursor: pointer">
              <input
                style="cursor: pointer"
                class="form-check-input"
                type="checkbox"
                id="showBigOrders"
                [(ngModel)]="showBigOrders"
                name="showBigOrders"
              />
            </div>
          </div>
        </span>
        <span class="status-indicator-undefined" *ngIf="canSpecial()">
          <div class="custom-switch-btn d-flex align-items-center">
            <label
              class="form-check-label me-2"
              for="showUndefinedParcels"
              style="cursor: pointer"
            >
              Visualizza anche colli pickerati non ancora affidati
            </label>
            <div class="form-check form-switch m-0" style="cursor: pointer">
              <input
                style="cursor: pointer"
                class="form-check-input"
                type="checkbox"
                id="showUndefinedParcels"
                [(ngModel)]="showUndefinedParcels"
                name="showUndefinedParcels"
              />
            </div>
          </div>
        </span>
      </div>

      <!--
                  <div class="d-flex justify-content-between flex-wrap w-100 align-items-end"> -->

      <!-- Filtri visibili solo se showFilters è true -->
      <div *ngIf="showFilters">
        <div class="d-flex flex-wrap gap-3 mb-3">
          <div class="mb-2">
            <input
              type="text"
              class="form-control"
              placeholder="Codice Collo"
              [(ngModel)]="searchParcelCode"
            />
          </div>
          <div class="mb-2">
            <input
              type="text"
              class="form-control"
              placeholder="Codice Bolla"
              [(ngModel)]="searchParcelWaybillCode"
            />
          </div>
          <div class="mb-2" *ngIf="canWithGeofencingTourBigOrder()">
            <input
              type="text"
              class="form-control"
              placeholder="Codici DDT"
              [(ngModel)]="searchDDTCodes"
            />
          </div>
        </div>
        <div class="d-flex flex-wrap gap-3 mb-3">
          <div
            class="mb-0"
            style="min-width: 200px"
            *ngIf="filteredClients.length > 1"
          >
            <div class="multi-select-wrapper">
              <ng-multiselect-dropdown
                *ngIf="filteredClients.length > 0 && dropdownSettingsClient"
                name="clients"
                [placeholder]="'Seleziona clienti'"
                [settings]="dropdownSettingsClient"
                [data]="filteredClients"
                [(ngModel)]="selectedClients"
                [ngModelOptions]="{ standalone: true }"
                (onSelect)="onClientsChange()"
                (onDeSelect)="onClientsChange()"
                (onSelectAll)="selectAllClients()"
                (onDeSelectAll)="deselectAllClients()"
              >
              </ng-multiselect-dropdown>
            </div>
          </div>
          <div
            class="mb-0"
            style="min-width: 200px"
            *ngIf="filteredBrands.length > 1"
          >
            <div class="multi-select-wrapper">
              <ng-multiselect-dropdown
                *ngIf="filteredBrands.length > 0 && dropdownSettingsBrand"
                name="brands"
                [placeholder]="'Seleziona marchi'"
                [settings]="dropdownSettingsBrand"
                [data]="filteredBrands"
                [(ngModel)]="selectedBrands"
                [ngModelOptions]="{ standalone: true }"
              >
              </ng-multiselect-dropdown>
            </div>
          </div>
          <div class="mb-2" *ngIf="canSpecial()">
            <select
              class="form-select"
              [(ngModel)]="filterOnlyWithCoordsAndNoDeliveryDate"
            >
              <option value="">
                Tutti i colli (data consegna e coordinate)
              </option>
              <option value="with_coords_no_delivery">
                Solo colli con coordinate ma senza data consegna
              </option>
            </select>
          </div>
          <div
            class="mb-2"
            *ngIf="dealers == null || (dealers != null && dealers.length > 1)"
          >
            <input
              type="text"
              class="form-control"
              placeholder="Codice Dealer"
              [(ngModel)]="searchDealerCode"
            />
          </div>
          <div
            class="mb-0"
            style="min-width: 300px; max-width: 450px"
            *ngIf="dealers == null || (dealers != null && dealers.length > 1)"
          >
            <div class="multi-select-wrapper">
              <ng-multiselect-dropdown
                name="dealers"
                [placeholder]="'Tutti i dealer'"
                [settings]="dropdownSettingsDealer"
                [data]="filteredDealers"
                [(ngModel)]="selectedDealers"
                [ngModelOptions]="{ standalone: true }"
                [disabled]="filteredDealers.length === 0"
              >
              </ng-multiselect-dropdown>
            </div>
          </div>
          <div class="mb-2" *ngIf="canSpecial()">
            <select class="form-select" [(ngModel)]="notificationStatus">
              <option value="">Tutti i colli (notificati e non)</option>
              <option value="not_notified">Solo colli non notificati</option>
              <option value="notified">Solo colli notificati</option>
            </select>
          </div>
          <div class="mb-2">
            <select class="form-select" [(ngModel)]="deliveryStatus">
              <option value="">Tutti i colli (consegnati e non)</option>
              <option value="not_delivered">Solo colli non consegnati</option>
              <option value="delivered">Solo colli consegnati</option>
            </select>
          </div>
          <div class="mb-2" *ngIf="canSpecial()">
            <select class="form-select" [(ngModel)]="modifyStatus">
              <option value="">Tutti i colli (armonizzati e non)</option>
              <option value="not_modified">Solo colli non armonizzati</option>
              <option value="modified">Solo colli armonizzati</option>
            </select>
          </div>
          <div class="mb-2" *ngIf="!isDealerUser">
            <select
              class="form-select"
              [(ngModel)]="onTimeStatus"
              name="onTimeStatus"
            >
              <option value="">Tutti i colli (in ritardo e non)</option>
              <option value="ON_TIME">Colli in orario</option>
              <option value="NOT_ON_TIME">Colli in ritardo</option>
              <option
                *ngIf="canWithGeofencingTourBigOrder()"
                value="DELAY_LT_2H"
              >
                ▹ Colli in ritardo ≤ 2h
              </option>
              <option
                *ngIf="canWithGeofencingTourBigOrder()"
                value="DELAY_2H_3H"
              >
                ▹ Colli in 2h &lt; ritardo ≤ 3h
              </option>
              <option
                *ngIf="canWithGeofencingTourBigOrder()"
                value="DELAY_3H_1D"
              >
                ▹ Colli in 3h &lt; ritardo ≤ 1 giorno
              </option>
              <option
                *ngIf="canWithGeofencingTourBigOrder()"
                value="DELAY_GT_1D"
              >
                ▹ Colli in ritardo &gt; 1 giorno
              </option>
            </select>
          </div>
          <div class="mb-2" *ngIf="canWithGeofencingTourBigOrder()">
            <select class="form-select" [(ngModel)]="inRangeStatus">
              <option value="">Tutte le coordinate</option>
              <option value="NOT_IN_RANGE">Solo coordinate errate</option>
              <option value="IN_RANGE">Solo coordinate corrette</option>
            </select>
          </div>
          <div class="mb-2" *ngIf="!isDealerUser">
            <select class="form-select" [(ngModel)]="withProblemsStatus">
              <option value="">Tutti i colli (con e senza problemi)</option>
              <option value="no_problems">Solo colli senza problemi</option>
              <option value="with_problems">Solo colli con problemi</option>
            </select>
          </div>
          <div class="mb-2" *ngIf="canUpdate()">
            <select
              class="form-select"
              [(ngModel)]="selectedCarrierCode"
              name="carrierCode"
            >
              <option value="">Tutti i vettori</option>
              <option
                *ngFor="let carrier of filteredCarriers"
                [value]="carrier.carrierCode"
              >
                {{ carrier.carrierName }} ({{ carrier.count ?? "–" }})
              </option>
            </select>
          </div>
          <div class="mb-2" *ngIf="canUpdate()">
            <select
              class="form-select"
              [(ngModel)]="warehouseFromCode"
              name="warehouseFromCode"
            >
              <option value="">Tutti i magazzini di partenza</option>
              <option
                *ngFor="let warehouse of filteredWarehousesFrom"
                [value]="warehouse.warehouseCode"
              >
                {{ warehouse.warehouseName }}
              </option>
            </select>
          </div>
          <div class="mb-2" *ngIf="canUpdate()">
            <select
              class="form-select"
              [(ngModel)]="warehouseCode"
              name="warehouseCode"
            >
              <option value="">Tutte le piattaforme (ultimo miglio)</option>
              <option
                *ngFor="let warehouse of filteredWarehouses"
                [value]="warehouse.warehouseCode"
              >
                {{ warehouse.warehouseName }}
              </option>
            </select>
          </div>
          <div class="mb-2">
            <select
              class="form-select"
              [(ngModel)]="selectedRegionCode"
              name="regionCode"
            >
              <option value="">Tutte le regioni</option>
              <option
                *ngFor="let region of filteredRegions"
                [value]="region.regionCode"
              >
                {{ region.regionName }} ({{ region.count ?? "–" }})
              </option>
            </select>
          </div>
          <div class="mb-2" *ngIf="canUpdate()">
            <select
              class="form-select"
              [(ngModel)]="selectedDeliveryType"
              name="deliveryType"
            >
              <option value="">Tutti i tour</option>
              <option
                *ngFor="let tour of filteredTours"
                [value]="tour.tourCode"
              >
                {{ tour.tourName }} ({{ tour.count ?? "–" }})
              </option>
            </select>
          </div>
          <div class="mb-2" *ngIf="canUpdate()">
            <select
              class="form-select"
              [(ngModel)]="scheduleType"
              name="scheduleType"
            >
              <option value="">Tutte (DMDC/A*B/A*C)</option>
              <option value="AxA">DMDC</option>
              <option value="AxB">A*B</option>
              <option value="AxC">A*C</option>
            </select>
          </div>
          <div class="mb-2" *ngIf="canUpdate()">
            <select
              class="form-select"
              [(ngModel)]="scheduleIsNight"
              name="scheduleIsNight"
            >
              <option value="">Tutte (Night/Day)</option>
              <option value="Y">Night</option>
              <option value="N">Day</option>
            </select>
          </div>
          <div class="mb-2" *ngIf="canSpecial()">
            <select
              class="form-select"
              [(ngModel)]="selectedDeliveryMethod"
              name="selectedDeliveryMethod"
            >
              <option value="">Tutte (via terra/aerea)</option>
              <option value="BY_ROAD">Via terra</option>
              <option value="BY_AIR">Via aerea</option>
            </select>
          </div>
          <div class="mb-2" *ngIf="canUpdate()">
            <select class="form-select" [(ngModel)]="justificationStatus">
              <option value="">Tutti i colli (giustificati e non)</option>
              <option value="not_justified">Solo colli non giustificati</option>
              <option value="justified">Solo colli giustificati</option>
            </select>
          </div>
          <div class="mb-2">
            <select class="form-select" [(ngModel)]="parcelDetailStatusFilter">
              <option
                *ngFor="let opt of parcelDetailStatusOptions"
                [value]="opt.value"
              >
                {{ opt.label }}
              </option>
            </select>
          </div>
          <div class="mb-2" *ngIf="canUpdate()">
            <select class="form-select" [(ngModel)]="misroutingStatus">
              <option value="">Tutti i colli (con e senza misrouting)</option>
              <option value="N">Solo colli senza misrouting</option>
              <option value="Y">Solo colli con misrouting</option>
            </select>
          </div>

          <!-- <div class="mb-2">
                      <input type="date" class="form-control" [(ngModel)]="parcelDateStart" />
                    </div>
                    <div class="mb-2">
                      <input type="date" class="form-control" [(ngModel)]="parcelDateEnd" />
                    </div> -->
          <!-- <div class="mb-2">
                      <div class="d-flex align-items-end flex-wrap">
                        <div class="d-flex">
                          <button class="btn btn-light" style="padding: 6px;" (click)="shiftCreationDates(-1)" title="Indietro di 1 giorno">
                            <i class="fa-solid fa-caret-left"></i>
                          </button>
                          <input type="date" class="form-control" [(ngModel)]="parcelDateStart" id="parcelDateStart" />
                        </div>
                        <div class="d-flex">
                          <input type="date" class="form-control" [(ngModel)]="parcelDateEnd" id="parcelDateEnd" />
                          <button class="btn btn-light" style="padding: 6px;" (click)="shiftCreationDates(1)" title="Avanti di 1 giorno">
                            <i class="fa-solid fa-caret-right"></i>
                          </button>
                        </div>
                      </div>
                    </div> -->

          <div class="mb-2 d-flex">
            <button
              class="btn btn-light shift-btn back"
              (click)="shiftCreationDates(-1)"
              title="Indietro di 1 giorno"
            >
              <i class="fa-solid fa-caret-left"></i>
            </button>
            <div class="d-flex align-items-end flex-wrap align-content-center">
              <!-- Data inizio -->
              <div class="position-relative" style="width: 200px">
                <label for="parcelDateStart" class="custom-label"
                  >Data inizio affido</label
                >
                <input
                  type="date"
                  id="parcelDateStart"
                  [(ngModel)]="parcelDateStart"
                  class="form-control no-padding-input"
                />
              </div>
              <!-- Data fine -->
              <div class="position-relative" style="width: 200px">
                <label for="parcelDateEnd" class="custom-label"
                  >Data fine affido</label
                >
                <input
                  type="date"
                  id="parcelDateEnd"
                  [(ngModel)]="parcelDateEnd"
                  class="form-control no-padding-input"
                />
              </div>
            </div>
            <button
              class="btn btn-light shift-btn forward"
              (click)="shiftCreationDates(1)"
              title="Avanti di 1 giorno"
            >
              <i class="fa-solid fa-caret-right"></i>
            </button>
          </div>
          <!-- <div class="mb-2 d-flex align-items-end">
                      <button class="btn btn-primary" (click)="applyFilters()">Applica Filtri</button>
                    </div> -->

          <div class="mb-2 d-flex" *ngIf="!isDealerUser">
            <button
              class="btn btn-light shift-btn back"
              (click)="shiftEstimatedDates(-1)"
              title="Indietro di 1 giorno"
            >
              <i class="fa-solid fa-caret-left"></i>
            </button>
            <div class="d-flex align-items-end flex-wrap align-content-center">
              <!-- Data inizio consegna stimata -->
              <div class="position-relative" style="width: 200px">
                <label
                  for="parcelEstimatedDeliveryDateStart"
                  class="custom-label"
                  >Data inizio consegna stimata</label
                >
                <input
                  type="date"
                  id="parcelEstimatedDeliveryDateStart"
                  [(ngModel)]="parcelEstimatedDeliveryDateStart"
                  class="form-control no-padding-input"
                />
              </div>
              <!-- Data fine consegna stimata -->
              <div class="position-relative" style="width: 200px">
                <label for="parcelEstimatedDeliveryDateEnd" class="custom-label"
                  >Data fine consegna stimata</label
                >
                <input
                  type="date"
                  id="parcelEstimatedDeliveryDateEnd"
                  [(ngModel)]="parcelEstimatedDeliveryDateEnd"
                  class="form-control no-padding-input"
                />
              </div>
            </div>
            <button
              class="btn btn-light shift-btn forward"
              (click)="shiftEstimatedDates(1)"
              title="Avanti di 1 giorno"
            >
              <i class="fa-solid fa-caret-right"></i>
            </button>
          </div>
        </div>

        <div class="d-flex justify-content-end gap-2">
          <button class="btn btn-primary" (click)="applyFilters()">
            Applica Filtri
          </button>
          <button class="btn btn-light" type="button" (click)="resetFilters()">
            Reset
          </button>
        </div>
      </div>

      <!--
                  </div> -->
    </div>
  </div>

  <div class="row px-3 mb-3">
    <div
      class="col-12 d-flex align-items-center gap-2 flex-wrap flex-md-nowrap parcels-toolbar"
    >
      <!-- <button title="Configura colonne" class="btn btn-outline-secondary" (click)="showConfig = true">
              <i class="bi bi-gear"></i>
            </button> -->
      <!-- Pulsanti allineati a destra (l'import può non esserci, quindi lo spazio lo dà un elemento vuoto) -->
      <div class="ms-auto"></div>

      <button
        *ngIf="canUpdate() || canSpecial()"
        class="btn btn-outline-warning toolbar-btn-justifications"
        type="button"
        (click)="openImportExcelModal()"
        matTooltip="Importa Excel Giustifiche"
      >
        <i class="fas fa-file-alt"></i>
      </button>

      <column-customize
        [(columns)]="columns"
        [storageKey]="'parcelTableConfig'"
      ></column-customize>

      <!-- bottone per mostrare il tracking collegato all'excel per mostrare la giustifica vettore -->
      <!-- <button *ngIf="canSpecial()"
                type="button"
                class="btn btn-warning"
                [title]="showHideTrackings ? 'Nascondi il tracking' : 'Mostra il tracking'"
                (click)="toggleAllComParcels()"
                tabindex="-1">

                <i class="fa" [ngClass]="showHideTrackings ? 'fa-eye-slash' : 'fa-eye'"></i>
            </button> -->

      <!-- Bottone Excel -->
      <!-- Export lato server di tutti i colli dei filtri applicati -->
      <button
        class="btn toolbar-btn toolbar-btn-excel"
        type="button"
        (click)="exportParcelsToExcel()"
        [disabled]="isExporting || totalRecords === 0"
        matTooltip="Esporta Excel"
      >
        <span
          *ngIf="exportingType === 'standard'"
          class="spinner-border spinner-border-sm"
          role="status"
        ></span>
        <i *ngIf="exportingType !== 'standard'" class="fas fa-file-excel"></i>
      </button>

      <button
        *ngIf="canSpecial()"
        class="btn toolbar-btn toolbar-btn-excel"
        type="button"
        (click)="exportParcelsOriginalToExcel()"
        [disabled]="isExporting || totalRecords === 0"
        matTooltip="Esporta Excel Con Dati Originali"
      >
        <span
          *ngIf="exportingType === 'original'"
          class="spinner-border spinner-border-sm"
          role="status"
        ></span>
        <i *ngIf="exportingType !== 'original'" class="fas fa-file-excel"
          ><sup style="font-size: small; padding-left: 5px">®</sup></i
        >
      </button>

      <!-- Select righe per pagina -->
      <select
        class="form-select toolbar-select"
        [(ngModel)]="itemsPerPage"
        (change)="onItemsPerPageChange()"
        matTooltip="Numero righe"
      >
        <option [ngValue]="10">10</option>
        <option [ngValue]="25">25</option>
        <option [ngValue]="50">50</option>
        <option [ngValue]="100">100</option>
      </select>

      <!-- Bottone reset -->
      <button
        class="btn toolbar-btn toolbar-btn-reset"
        type="button"
        (click)="resetItemsPerPage()"
        matTooltip="Reset numero righe"
      >
        <i class="fa fa-undo"></i>
      </button>
    </div>
  </div>

  <!-- Errore filtri -->
  <div *ngIf="dateError" class="alert alert-warning mx-3">
    <div>
      <i class="fas fa-exclamation-triangle me-2"></i>
      <span>{{ dateError }}</span>
    </div>
  </div>

  <!-- Tabella Colli -->
  <div *ngIf="!isLoading && parcels.length > 0">
    <div class="table-wrapper mx-3">
      <table class="table fixed-header-table table-hover">
        <thead class="bg-light">
          <tr>
            <!-- Apre/chiude il dettaglio di tutte le righe della pagina, come il click sulla riga -->
            <th *ngIf="canWithGeofencingTourBigOrder()" class="expand-all-th">
              <button
                type="button"
                class="expand-all-btn"
                (click)="toggleAllComParcels()"
                [attr.aria-label]="
                  hasAnyComParcelsOpen()
                    ? 'Comprimi tutte le righe'
                    : 'Espandi tutte le righe'
                "
                [matTooltip]="
                  hasAnyComParcelsOpen()
                    ? 'Comprimi tutte le righe'
                    : 'Espandi tutte le righe'
                "
              >
                <i
                  class="fas"
                  [ngClass]="
                    hasAnyComParcelsOpen() ? 'fa-compress-alt' : 'fa-expand-alt'
                  "
                ></i>
              </button>
            </th>
            <ng-container *ngFor="let col of columns | orderBy: 'order'">
              <th
                *ngIf="col.visible && (!col.updatableOnly || canUpdate())"
                [style.width]="col.width ? col.width : null"
                scope="col"
                [style.cursor]="col.sortable ? 'pointer' : 'default'"
                (click)="col.sortable && setSort(col.field)"
              >
                {{ col.label | translate }}

                <i
                  *ngIf="col.sortable"
                  class="bi"
                  [ngClass]="{
                    'bi-arrow-down':
                      sortState.active === col.field &&
                      sortState.direction === 'desc',
                    'bi-arrow-up':
                      sortState.active === col.field &&
                      sortState.direction === 'asc',
                    'bi-arrow-down-up':
                      sortState.active !== col.field ||
                      sortState.direction === '',
                  }"
                >
                </i>
              </th>
            </ng-container>
          </tr>
        </thead>

        <tbody>
          <ng-container
            *ngFor="
              let p of filteredParcels
                | paginate
                  : {
                      id: 'parcel-pagination',
                      itemsPerPage: itemsPerPage,
                      currentPage: currentPage,
                      totalItems: totalRecords,
                    }
            "
          >
            <!--   (click)="toggleTrackings(p)" -->
            <tr
              (click)="toggleAndLoadComParcels(p)"
              [style.cursor]="isRowClickable(p) ? 'pointer' : 'default'"
            >
              <td *ngIf="canWithGeofencingTourBigOrder()"></td>
              <ng-container *ngFor="let col of columns | orderBy: 'order'">
                <td *ngIf="col.visible && (!col.updatableOnly || canUpdate())">
                  <!-- Render dinamico -->
                  <ng-container [ngSwitch]="col.field">
                    <span
                      *ngSwitchCase="'parcelWaybillStatus'"
                      class="status-indicator"
                      [ngClass]="{
                        'status-active': p.parcelWaybillStatus === 'ACTIVE',
                        'status-pending': p.parcelWaybillStatus === 'PENDING',
                        'status-unsent': p.parcelWaybillStatus === 'UNSENT',
                        'status-cancelled':
                          p.parcelWaybillStatus === 'CANCELLED' ||
                          p.parcelWaybillStatus === 'UNDEFINED' ||
                          p.parcelWaybillStatus === 'NOT_DELIVERED',
                        'status-delivered':
                          p.parcelWaybillStatus === 'DELIVERED',
                      }"
                    >
                      {{ p.parcelWaybillStatus }}
                    </span>

                    <!--  VGIIII -->
                    <span
                      *ngSwitchCase="'parcelDetailStatus'"
                      class="detail-status-indicator"
                      [ngClass]="{
                        'status-prepared': p.parcelDetailStatus === 'PREPARED',
                        'status-intriptotp':
                          p.parcelDetailStatus === 'IN_TRIP_TO_TP',
                        'status-intrip': p.parcelDetailStatus === 'IN_TRIP',
                        'status-closed': p.parcelDetailStatus === 'CLOSED',
                        'status-suspended':
                          p.parcelDetailStatus === 'SUSPENDED',
                      }"
                    >
                      <i
                        class="status-icon fas"
                        [ngClass]="{
                          'fa-box-open': p.parcelDetailStatus === 'PREPARED',
                          'fa-route': p.parcelDetailStatus === 'IN_TRIP_TO_TP',
                          'fa-truck-moving': p.parcelDetailStatus === 'IN_TRIP',
                          'fa-check-circle': p.parcelDetailStatus === 'CLOSED',
                          'fa-pause-circle':
                            p.parcelDetailStatus === 'SUSPENDED',
                        }"
                      ></i>

                      <span class="status-label">
                        {{ getParcelDetailStatusLabel(p.parcelDetailStatus) }}
                      </span>
                    </span>

                    <!--  <ng-container *ngSwitchCase="'parcelWaybillCode'">
                        {{ p.parcelWaybillCode?.substring(2, 8)?.padStart(7, '0') }}
                    </ng-container>

                    <ng-container *ngSwitchCase="'parcelWaybillCodeFull'">
                        {{ p.parcelWaybillCode }}
                    </ng-container> -->

                    <ng-container *ngSwitchCase="'parcelHasMisrouting'">
                      <i
                        *ngIf="p.parcelHasMisrouting === 'Y'"
                        class="fa-solid fa-triangle-exclamation text-danger"
                        style="padding-top: 8px"
                        matTooltip="Misrouting rilevato"
                        matTooltipClass="misrouting-tooltip"
                        matTooltipPosition="above"
                        matTooltipShowDelay="0"
                      >
                      </i>
                    </ng-container>

                    <span *ngSwitchCase="'parcelWaybillOriginLocation'"
                      >{{ p.parcelWarehouseExternalCode }}
                      {{ p.parcelWaybillOriginLocation }}</span
                    >

                    <ng-container *ngSwitchCase="'parcelOriginalWaybillCode'">
                      <ng-container
                        *ngIf="
                          p.parcelClientCode === 'CLT00001';
                          else normalWaybill
                        "
                      >
                        {{ p.parcelOriginalWaybillCode ?? p.parcelWaybillCode }}
                        <!-- {{ (p.parcelOriginalWaybillCode ?? p.parcelWaybillCode)?.substring(2, 8)?.padStart(7, '0') }} -->
                      </ng-container>

                      <ng-template #normalWaybill>
                        {{ p.parcelOriginalWaybillCode ?? p.parcelWaybillCode }}
                      </ng-template>
                    </ng-container>

                    <ng-container *ngSwitchCase="'parcelWaybillCode'">
                      {{
                        p.parcelOriginalWaybillCode ? p.parcelWaybillCode : ""
                      }}
                    </ng-container>

                    <ng-container *ngSwitchCase="'parcelWaybillCodeFull'">
                      <ng-container *ngIf="p.parcelClientCode === 'CLT00001'">
                        {{ p.parcelOriginalWaybillCode ?? p.parcelWaybillCode }}
                      </ng-container>
                    </ng-container>

                    <!-- Date -->
                    <span *ngSwitchCase="'parcelDeliveryChangeCutoffDate'">
                      {{
                        p.parcelDeliveryChangeCutoffDate
                          | date: "dd/MM/yyyy HH:mm"
                      }}
                    </span>
                    <span *ngSwitchCase="'parcelDate'">{{
                      p.parcelDate | date: "dd/MM/yyyy HH:mm"
                    }}</span>
                    <span *ngSwitchCase="'parcelDeliveryDate'">{{
                      p.parcelDeliveryDate | date: "dd/MM/yyyy HH:mm"
                    }}</span>
                    <span *ngSwitchCase="'parcelEstimatedDeliveryDate'">{{
                      p.parcelEstimatedDeliveryDate | date: "dd/MM/yyyy HH:mm"
                    }}</span>
                    <span *ngSwitchCase="'parcelWaybillLastMileOrigin'"
                      >{{ getWarehouseName(p.parcelWaybillLastMileOrigin) }}
                    </span>

                    <ng-container *ngSwitchCase="'parcelModifyManual'">
                      <button
                        *ngIf="
                          canSpecial() && p.parcelDeliveryDateIsForced != null
                        "
                        style="font-size: small"
                        class="btn btn-light"
                        type="button"
                        (click)="
                          viewDetailsModifiesManual(p); $event.stopPropagation()
                        "
                        title="Visualizza il dettaglio delle modifiche"
                      >
                        <i
                          *ngIf="p.parcelDeliveryDateIsUpdated === 'Y'"
                          class="fas fa-pencil-alt"
                          style="font-size: x-small"
                          title="Data modificata"
                        ></i>
                        <i
                          *ngIf="p.parcelDeliveryDateIsUpdated != 'Y'"
                          class="fa-solid fa-plus"
                          style="font-size: x-small"
                          title="Data aggiunta"
                        ></i>
                        {{
                          p.parcelModifyManual
                            ? (p.parcelModifyManual | date: "dd/MM/yyyy HH:mm")
                            : ""
                        }}
                      </button>
                    </ng-container>

                    <span
                      *ngSwitchCase="'parcelDeliveryChangeCutoffCountdown'"
                      [ngClass]="{
                        'cutoff-warning': p.parcelDeliveryChangeCutoffWarning,
                        'cutoff-expired': p.parcelDeliveryChangeCutoffExpired,
                      }"
                    >
                      {{ p.parcelDeliveryChangeCutoffCountdown || "" }}
                    </span>

                    <!-- Stato OnTime -->
                    <ng-container *ngSwitchCase="'parcelOnTime'">
                      <span
                        class="is-valid"
                        *ngIf="p.parcelOnTime === 'ON_TIME'"
                        >Si</span
                      >
                      <span
                        class="is-invalid"
                        *ngIf="p.parcelOnTime === 'NOT_ON_TIME'"
                        >No</span
                      >
                      <span
                        *ngIf="
                          p.parcelOnTime !== 'ON_TIME' &&
                          p.parcelOnTime !== 'NOT_ON_TIME'
                        "
                        >{{ p.parcelOnTime }}</span
                      >
                    </ng-container>

                    <!-- Giustifica -->
                    <span *ngSwitchCase="'parcelJustificationId'">
                      <button
                        *ngIf="
                          p.parcelOnTime === 'NOT_ON_TIME' ||
                          p.parcelDeliveryDate == null
                        "
                        type="button"
                        class="btn btn-sm"
                        [ngClass]="
                          p.parcelJustificationId
                            ? 'btn-outline-warning'
                            : 'btn-outline-secondary'
                        "
                        (click)="
                          openJustificationModal(p); $event.stopPropagation()
                        "
                        [matTooltip]="
                          p.parcelJustificationId
                            ? 'Modifica giustificazione'
                            : 'Aggiungi giustificazione'
                        "
                      >
                        <i class="fas fa-file-alt"></i>
                      </button>
                    </span>

                    <span *ngSwitchCase="'parcelNote'">
                      <button
                        type="button"
                        class="btn btn-sm border-0"
                        [ngClass]="
                          p.parcelNote
                            ? 'btn-outline-warning'
                            : 'btn-outline-secondary'
                        "
                        (click)="openNoteModal(p); $event.stopPropagation()"
                        [matTooltip]="
                          p.parcelNote ? 'Modifica note' : 'Aggiungi note'
                        "
                      >
                        <i class="fas fa-note-sticky"></i>
                      </button>
                    </span>

                    <!-- Mail inviata ai vettori -->
                    <span *ngSwitchCase="'waybillCarriersSentEmails'">
                      <button
                        *ngIf="p.waybillCarriersSentEmails"
                        type="button"
                        class="btn btn-sm border-0 carrier-mail-btn carrier-mail-sent"
                        (click)="
                          openCarrierMailModal(p); $event.stopPropagation()
                        "
                        matTooltip="Dettagli invio mail"
                        matTooltipPosition="above"
                      >
                        <i class="fas fa-envelope-open"></i>
                      </button>
                      <span
                        *ngIf="!p.waybillCarriersSentEmails"
                        class="carrier-mail-not-sent"
                        matTooltip="Mail non ancora inviata ai vettori"
                        matTooltipPosition="above"
                      >
                        <i class="fas fa-envelope"></i>
                      </span>
                    </span>

                    <!-- DeliveryMethod -->
                    <ng-container *ngSwitchCase="'parcelWaybillDeliveryMethod'">
                      <span *ngIf="p.parcelWaybillDeliveryMethod === 'BY_ROAD'"
                        >Via terra</span
                      >
                      <span *ngIf="p.parcelWaybillDeliveryMethod === 'BY_AIR'"
                        >Via aerea</span
                      >
                      <span
                        *ngIf="
                          p.parcelWaybillDeliveryMethod !== 'BY_ROAD' &&
                          p.parcelWaybillDeliveryMethod !== 'BY_AIR'
                        "
                      >
                        {{ p.parcelWaybillDeliveryMethod }}
                      </span>
                    </ng-container>

                    <!-- DeliveryStatus -->
                    <ng-container *ngSwitchCase="'parcelDeliveryStatus'">
                      {{
                        p.parcelDeliveryStatus === "DELIVERED"
                          ? "Consegnato"
                          : p.parcelDeliveryStatus
                      }}
                    </ng-container>

                    <!-- Coordinates -->
                    <ng-container *ngSwitchCase="'parcelLatitude'">
                      <span
                        [ngClass]="{
                          'is-invalid':
                            p.coordinatesInRange == 'NOT_IN_RANGE' &&
                            p.parcelLatitude != null,
                          'is-valid': p.coordinatesInRange == 'IN_RANGE',
                        }"
                        >{{ p.parcelLatitude }}</span
                      >
                    </ng-container>
                    <ng-container *ngSwitchCase="'parcelLongitude'">
                      <span
                        [ngClass]="{
                          'is-invalid':
                            p.coordinatesInRange == 'NOT_IN_RANGE' &&
                            p.parcelLatitude != null,
                          'is-valid': p.coordinatesInRange == 'IN_RANGE',
                        }"
                        >{{ p.parcelLongitude }}</span
                      >
                    </ng-container>

                    <!-- Distance -->
                    <ng-container *ngSwitchCase="'distanceInMeters'">
                      {{
                        p.distanceInMeters
                          ? (p.distanceInMeters | number: "1.0-0")
                          : ""
                      }}
                    </ng-container>

                    <!-- POD -->
                    <ng-container *ngSwitchCase="'pod'">
                      <button
                        *ngIf="p.isRestrictedClient === 'Y'"
                        type="button"
                        class="btn btn-sm btn-outline-primary"
                        (click)="
                          downloadPodDocument(
                            p.parcelWaybillCode,
                            p.waybillShipmentCode
                          )
                        "
                        [hidden]="
                          p.parcelDetailStatus != 'CLOSED' ||
                          (p.parcelOriginalWaybillCode != null &&
                            p.parcelOriginalWaybillCode != p.parcelWaybillCode)
                        "
                        matTooltip="Scarica POD"
                      >
                        <i class="fas fa-file-pdf"></i>
                      </button>
                    </ng-container>

                    <!-- Azioni -->
                    <!-- <ng-container *ngSwitchCase="'actions'">
                                        <button *ngIf="p.parcelWaybillStatus != 'PENDING' && p.parcelNotifiedStatus != 'SENT_TO_BMW' && p.parcelNotifiedStatus != 'VIEWED'" class="btn btn-sm btn-outline-primary ms-1"
                                                (click)="openEditModal(p); $event.stopPropagation()">
                                            <i class="fas fa-pencil-alt"></i>
                                        </button>
                                        <button *ngIf="p.parcelWaybillStatus != 'PENDING' && p.parcelNotifiedStatus != 'SENT_TO_BMW' && p.parcelNotifiedStatus != 'VIEWED' && p.parcelDeliveryStatus === 'DELIVERED'" class="btn btn-sm btn-outline-primary ms-1"
                                                (click)="openRollbackModal(p); $event.stopPropagation()"
                                                matTooltip="Annulla consegna">
                                            <i class="fa-solid fa-undo"></i>
                                        </button>
                                    </ng-container> -->

                    <!-- Default -->
                    <span *ngSwitchDefault>{{ getValue(p, col.field) }}</span>
                  </ng-container>
                </td>
              </ng-container>
            </tr>

            <tr *ngIf="p.showComParcels">
              <td colspan="12" class="p-3">
                <div class="card">
                  <div class="card-body">
                    <ul class="nav nav-tabs mb-3" *ngIf="canUpdate()">
                      <li class="nav-item">
                        <button
                          type="button"
                          class="nav-link"
                          [class.active]="
                            p.activeTab === 'tracking' || !p.activeTab
                          "
                          (click)="p.activeTab = 'tracking'"
                        >
                          Tracking
                        </button>
                      </li>
                      <li class="nav-item">
                        <button
                          type="button"
                          class="nav-link"
                          [class.active]="p.activeTab === 'map'"
                          (click)="p.activeTab = 'map'"
                        >
                          Mappa
                        </button>
                      </li>
                    </ul>

                    <div
                      class="tab-content"
                      *ngIf="canUpdate(); else mapOnlyTpl"
                    >
                      <!-- TAB TRACKING -->
                      <div
                        class="tab-pane fade"
                        [class.show]="
                          p.activeTab === 'tracking' || !p.activeTab
                        "
                        [class.active]="
                          p.activeTab === 'tracking' || !p.activeTab
                        "
                      >
                        <h6
                          class="mb-3 text-muted"
                          style="font-weight: 400; font-size: 0.85rem"
                        >
                          <ng-container
                            *ngIf="p.parcelDeliveryType || p.parcelDescription"
                          >
                            Descrizione Collo:
                            <ng-container *ngIf="p.parcelDeliveryType">
                              <span style="font-weight: 600">{{
                                p.parcelDeliveryType
                              }}</span>
                            </ng-container>
                            <ng-container
                              *ngIf="
                                p.parcelDeliveryType && p.parcelDescription
                              "
                            >
                              -
                            </ng-container>
                            <ng-container *ngIf="p.parcelDescription">
                              <span style="font-weight: 600">{{
                                p.parcelDescription
                              }}</span>
                            </ng-container>
                          </ng-container>

                          <ng-container *ngIf="p.parcelType">
                            <ng-container
                              *ngIf="
                                p.parcelDeliveryType || p.parcelDescription
                              "
                            >
                              |
                            </ng-container>
                            Tipo:
                            <span style="font-weight: 600">{{
                              p.parcelType
                            }}</span>
                          </ng-container>

                          <ng-container *ngIf="p.parcelPalletType">
                            <ng-container *ngIf="p.parcelType">
                              |
                            </ng-container>
                            Pallet:
                            <span style="font-weight: 600">{{
                              p.parcelPalletType
                            }}</span>
                          </ng-container>

                          <ng-container *ngIf="p.parcelPalletDescription">
                            <ng-container
                              *ngIf="p.parcelType || p.parcelPalletType"
                            >
                              |
                            </ng-container>
                            Desc. pallet:
                            <span style="font-weight: 600">{{
                              p.parcelPalletDescription
                            }}</span>
                          </ng-container>
                        </h6>

                        <div *ngIf="p.loadingComParcels" class="mb-2">
                          <div
                            class="spinner-border spinner-border-sm"
                            role="status"
                          ></div>
                          <small class="ms-2">Caricamento...</small>
                        </div>
                        <div
                          *ngIf="p.errorLoadingComParcels"
                          class="alert alert-warning py-1 px-2"
                        >
                          Errore nel caricamento
                        </div>

                        <div
                          *ngIf="p.isRoutingPresent === 'N'"
                          class="text-center py-3"
                        >
                          <div
                            class="d-inline-flex align-items-center gap-2 px-3 py-2 rounded"
                            style="background: white; border: 1px solid #e0e0e0"
                          >
                            <i
                              class="fa-regular fa-circle-question grey-text"
                            ></i>
                            <span
                              class="grey-text fw-semibold"
                              style="font-size: 0.95rem"
                            >
                              Instradamento non definito
                            </span>
                          </div>
                        </div>

                        <div
                          *ngIf="
                            p.isRoutingPresent === 'Y' && !p.loadingComParcels
                          "
                        >
                          <ng-container
                            *ngIf="getComParcelsNoMisrouting(p) as comNoMis"
                          >
                            <div
                              class="timeline-container"
                              *ngIf="{
                                origin: getOriginTransit(comNoMis),
                                first: getFirstTransport(comNoMis),
                              } as head"
                            >
                              <div class="timeline-step">
                                <div class="step-label top">
                                  <div
                                    class="text truncate grey-text"
                                    [title]="
                                      getWarehouseShortNameComParcel(
                                        comNoMis[0]
                                          ?.parcelComplementaryWarehouseFrom
                                      ) ||
                                      getDealerName(
                                        comNoMis[0]
                                          ?.parcelComplementaryDealerFrom
                                      )
                                    "
                                  >
                                    {{
                                      getWarehouseShortNameComParcel(
                                        comNoMis[0]
                                          ?.parcelComplementaryWarehouseFrom
                                      ) ||
                                        getDealerName(
                                          comNoMis[0]
                                            ?.parcelComplementaryDealerFrom
                                        )
                                    }}
                                  </div>
                                </div>
                                <div
                                  class="circle"
                                  [ngClass]="
                                    head.origin
                                      ? statusCircleClass(
                                          head.origin.parcelComplementaryStatus
                                        )
                                      : ''
                                  "
                                  [class.hovered]="
                                    !!head.origin && hovered === head.origin
                                  "
                                >
                                  <i
                                    class="fa-regular fa-flag"
                                    [ngClass]="
                                      head.origin
                                        ? getTextClassComParcels(
                                            head.origin.parcelComplementaryStatus
                                          )
                                        : ''
                                    "
                                    [style.color]="head.origin ? null : '#757575'"
                                  ></i>
                                </div>
                                <div
                                  class="line"
                                  [ngClass]="{
                                    'line-green':
                                      head.first?.parcelComplementaryStatus ===
                                      'EXECUTED',
                                    'line-blue':
                                      head.first?.parcelComplementaryStatus ===
                                      'IN_PROGRESS',
                                    'line-yellow':
                                      head.first?.parcelComplementaryStatus ===
                                      'UNKNOWN',
                                    'line-red':
                                      head.first?.parcelComplementaryStatus ===
                                        'ERROR' ||
                                      head.first?.parcelComplementaryStatus ===
                                        'MISROUTING',
                                    'line-grey':
                                      head.first?.parcelComplementaryStatus ===
                                      'PLANNED',
                                  }"
                                  [class.hovered]="hovered === head.first"
                                >
                                  <div
                                    class="transport-label"
                                    [class.hovered]="hovered === head.first"
                                  >
                                    <i
                                      [ngClass]="{
                                        fa: true,
                                        'fa-truck': true,
                                        'green-text':
                                          head.first
                                            ?.parcelComplementaryStatus ===
                                          'EXECUTED',
                                        'light-blue-text':
                                          head.first
                                            ?.parcelComplementaryStatus ===
                                          'IN_PROGRESS',
                                        'yellow-text':
                                          head.first
                                            ?.parcelComplementaryStatus ===
                                          'UNKNOWN',
                                        'red-text':
                                          head.first
                                            ?.parcelComplementaryStatus ===
                                            'ERROR' ||
                                          head.first
                                            ?.parcelComplementaryStatus ===
                                            'MISROUTING',
                                        'grey-text':
                                          head.first
                                            ?.parcelComplementaryStatus ===
                                            'PLANNED' ||
                                          !head.first
                                            ?.parcelComplementaryStatus,
                                      }"
                                      [class.hovered]="hovered === head.first"
                                    ></i>
                                    <span
                                      [ngClass]="{
                                        'green-text':
                                          head.first
                                            ?.parcelComplementaryStatus ===
                                          'EXECUTED',
                                        'light-blue-text':
                                          head.first
                                            ?.parcelComplementaryStatus ===
                                          'IN_PROGRESS',
                                        'yellow-text':
                                          head.first
                                            ?.parcelComplementaryStatus ===
                                          'UNKNOWN',
                                        'red-text':
                                          head.first
                                            ?.parcelComplementaryStatus ===
                                            'ERROR' ||
                                          head.first
                                            ?.parcelComplementaryStatus ===
                                            'MISROUTING',
                                        'grey-text':
                                          head.first
                                            ?.parcelComplementaryStatus ===
                                            'PLANNED' ||
                                          !head.first
                                            ?.parcelComplementaryStatus,
                                      }"
                                      [class.hovered]="hovered === head.first"
                                    >
                                      {{
                                        head.first?.parcelComplementaryCarrierCode
                                                ? getCarrierName(head.first!.parcelComplementaryCarrierCode)
                                                : null
                                      }}
                                    </span>
                                  </div>
                                </div>
                              </div>

                              <div
                                class="timeline-step"
                                *ngFor="let pair of getComParcelPairs(p)"
                              >
                                <div
                                  *ngIf="pair.transit"
                                  class="timeline-step"
                                  [class.hovered]="hovered === pair.transit"
                                >
                                  <div
                                    class="step-label top"
                                    [class.hovered]="hovered === pair.transit"
                                  >
                                    <div
                                      class="text truncate"
                                      [ngClass]="
                                        getTextClassComParcels(
                                          pair.transit.parcelComplementaryStatus
                                        )
                                      "
                                      [title]="
                                        getWarehouseShortNameComParcel(
                                          pair.transit
                                            .parcelComplementaryWarehouseFrom
                                        ) ||
                                        getDealerName(
                                          pair.transit
                                            .parcelComplementaryDealerFrom
                                        )
                                      "
                                      [class.hovered]="hovered === pair.transit"
                                    >
                                      {{
                                        getWarehouseShortNameComParcel(
                                          pair.transit
                                            .parcelComplementaryWarehouseFrom
                                        ) ||
                                          getDealerName(
                                            pair.transit
                                              .parcelComplementaryDealerFrom
                                          )
                                      }}
                                    </div>
                                  </div>
                                  <div
                                    class="circle"
                                    [class.hovered]="hovered === pair.transit"
                                    [ngClass]="
                                      statusCircleClass(
                                        pair.transit.parcelComplementaryStatus
                                      )
                                    "
                                  >
                                    <i
                                      [ngClass]="{
                                        fa: true,
                                        'fa-warehouse': true,
                                        'green-text':
                                          pair.transit
                                            .parcelComplementaryStatus ===
                                          'EXECUTED',
                                        'light-blue-text':
                                          pair.transit
                                            .parcelComplementaryStatus ===
                                          'IN_PROGRESS',
                                        'yellow-text':
                                          pair.transit
                                            .parcelComplementaryStatus ===
                                          'UNKNOWN',
                                        'red-text':
                                          pair.transit
                                            .parcelComplementaryStatus ===
                                            'ERROR' ||
                                          pair.transit
                                            .parcelComplementaryStatus ===
                                            'MISROUTING',
                                        'grey-text':
                                          pair.transit
                                            .parcelComplementaryStatus ===
                                            'PLANNED' ||
                                          !pair.transit
                                            .parcelComplementaryStatus,
                                      }"
                                      [class.hovered]="hovered === pair.transit"
                                    ></i>
                                  </div>
                                </div>

                                <div
                                  *ngIf="pair.transport"
                                  class="line"
                                  [class.hovered]="hovered === pair.transport"
                                  [ngClass]="{
                                    'line-green':
                                      pair.transport
                                        .parcelComplementaryStatus ===
                                      'EXECUTED',
                                    'line-blue':
                                      pair.transport
                                        .parcelComplementaryStatus ===
                                      'IN_PROGRESS',
                                    'line-yellow':
                                      pair.transport
                                        .parcelComplementaryStatus ===
                                      'UNKNOWN',
                                    'line-red':
                                      pair.transport
                                        .parcelComplementaryStatus === 'ERROR',
                                    'line-grey':
                                      pair.transport
                                        .parcelComplementaryStatus ===
                                        'PLANNED' ||
                                      !pair.transport.parcelComplementaryStatus,
                                  }"
                                >
                                  <div
                                    class="transport-label"
                                    [class.hovered]="hovered === pair.transport"
                                  >
                                    <i
                                      [ngClass]="{
                                        fa: true,
                                        'fa-truck': true,
                                        'green-text':
                                          pair.transport
                                            .parcelComplementaryStatus ===
                                          'EXECUTED',
                                        'light-blue-text':
                                          pair.transport
                                            .parcelComplementaryStatus ===
                                          'IN_PROGRESS',
                                        'yellow-text':
                                          pair.transport
                                            .parcelComplementaryStatus ===
                                          'UNKNOWN',
                                        'red-text':
                                          pair.transport
                                            .parcelComplementaryStatus ===
                                          'ERROR',
                                        'grey-text':
                                          pair.transport
                                            .parcelComplementaryStatus ===
                                            'PLANNED' ||
                                          !pair.transport
                                            .parcelComplementaryStatus,
                                      }"
                                      [class.hovered]="
                                        hovered === pair.transport
                                      "
                                    ></i>
                                    <span
                                      [ngClass]="{
                                        'green-text':
                                          pair.transport
                                            .parcelComplementaryStatus ===
                                          'EXECUTED',
                                        'light-blue-text':
                                          pair.transport
                                            .parcelComplementaryStatus ===
                                          'IN_PROGRESS',
                                        'yellow-text':
                                          pair.transport
                                            .parcelComplementaryStatus ===
                                          'UNKNOWN',
                                        'red-text':
                                          pair.transport
                                            .parcelComplementaryStatus ===
                                          'ERROR',
                                        'grey-text':
                                          pair.transport
                                            .parcelComplementaryStatus ===
                                            'PLANNED' ||
                                          !pair.transport
                                            .parcelComplementaryStatus,
                                      }"
                                      [class.hovered]="
                                        hovered === pair.transport
                                      "
                                    >
                                      {{
                                        pair.transport.parcelComplementaryCarrierCode
                                                    ? getCarrierName(pair.transport.parcelComplementaryCarrierCode)
                                                    : null	
                                      }}
                                    </span>
                                  </div>
                                </div>
                              </div>

                              <div
                                class="timeline-step"
                                [ngClass]="
                                  p.parcelDeliveryDate ? 'done' : 'empty'
                                "
                              >
                                <div class="step-label top">
                                  <div
                                    class="text truncate"
                                    [ngClass]="
                                      p.parcelDeliveryDate
                                        ? 'green-text'
                                        : 'grey-text'
                                    "
                                    [title]="
                                      getWarehouseShortNameComParcel(
                                        lastTo(comNoMis)
                                      ) || getDealerName(lastDealerTo(comNoMis))
                                    "
                                  >
                                    {{
                                      getWarehouseShortNameComParcel(
                                        lastTo(comNoMis)
                                      ) || getDealerName(lastDealerTo(comNoMis))
                                    }}
                                  </div>
                                </div>
                                <div
                                  class="circle"
                                  [ngClass]="{
                                    done: p.parcelDeliveryDate,
                                    empty: !p.parcelDeliveryDate,
                                  }"
                                >
                                  <i
                                    [ngClass]="{
                                      fa: true,
                                      'fa-flag-checkered': true,
                                      'green-text': p.parcelDeliveryDate,
                                      'grey-text': !p.parcelDeliveryDate,
                                    }"
                                  ></i>
                                </div>
                              </div>
                            </div>

                            <!-- TABELLA con i dettagli -->
                            <div class="table-responsive">
                              <table
                                class="table table-sm table-hover align-middle table-com-parcels"
                              >
                                <thead class="table-light">
                                  <tr>
                                    <th style="width: 40px">Stato</th>
                                    <th>Tour</th>
                                    <th>Tipo</th>
                                    <th>Partenza Da</th>
                                    <th>Arrivo A</th>
                                    <th>Inizio evento</th>
                                    <th>Fine evento</th>
                                    <th>Vettore</th>
                                    <th>Borderò</th>
                                    <th>Viaggio</th>
                                    <th>Giustifica</th>
                                    <!-- <th>Azioni</th> -->
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr
                                    *ngFor="let c of p.comParcels"
                                    (mouseenter)="hovered = c"
                                    (mouseleave)="hovered = null"
                                    [ngClass]="{
                                      'table-misrouting':
                                        c.parcelComplementaryStatus ===
                                        'MISROUTING',
                                    }"
                                  >
                                    <td>
                                      <i [ngClass]="typeIconRow(c)"></i>
                                      <span
                                        style="
                                          font-size: 0.8rem;
                                          padding-left: 5px;
                                        "
                                        [ngClass]="
                                          getTextClassComParcels(
                                            c.parcelComplementaryStatus
                                          )
                                        "
                                        >{{ c.parcelComplementaryStatus }}</span
                                      >
                                    </td>
                                    <td>
                                      {{
                                        getTourRoutingCode(
                                          c.parcelComplementaryTourRoutingId
                                        )
                                      }}
                                    </td>
                                    <td>{{ c.parcelComplementaryType }}</td>
                                    <td>
                                      {{
                                        getWarehouseNameComParcel(
                                          c.parcelComplementaryWarehouseFrom
                                        ) ||
                                          getDealerName(
                                            c.parcelComplementaryDealerFrom
                                          )
                                      }}
                                      <span
                                        *ngIf="
                                          getWarehouseShortNameComParcel(
                                            c.parcelComplementaryWarehouseFrom
                                          )
                                        "
                                      >
                                        ({{
                                          getWarehouseShortNameComParcel(
                                            c.parcelComplementaryWarehouseFrom
                                          )
                                        }})
                                      </span>
                                    </td>
                                    <td>
                                      {{
                                        getWarehouseNameComParcel(
                                          c.parcelComplementaryWarehouseTo
                                        ) ||
                                          getDealerName(
                                            c.parcelComplementaryDealerTo
                                          )
                                      }}
                                      <span
                                        *ngIf="
                                          getWarehouseShortNameComParcel(
                                            c.parcelComplementaryWarehouseTo
                                          )
                                        "
                                      >
                                        ({{
                                          getWarehouseShortNameComParcel(
                                            c.parcelComplementaryWarehouseTo
                                          )
                                        }})
                                      </span>
                                    </td>
                                    <td>
                                      {{
                                        c.parcelComplementaryEventStart
                                          ? (c.parcelComplementaryEventStart
                                            | date: "dd/MM/yyyy HH:mm")
                                          : ""
                                      }}
                                    </td>
                                    <td>
                                      {{
                                        c.parcelComplementaryEventEnd
                                          ? (c.parcelComplementaryEventEnd
                                            | date: "dd/MM/yyyy HH:mm")
                                          : ""
                                      }}
                                    </td>
                                    <td>
                                      {{
                                        c.parcelComplementaryCarrierCode
                                          ? getCarrierName(c.parcelComplementaryCarrierCode)
                                          : null		
                                      }}
                                    </td>
                                    <td>{{ c.loadingListCode }}</td>
                                    <td>{{ c.parcelComplementaryTripCode }}</td>
                                    <td>
                                      <button
                                        *ngIf="isLastComParcel(c, p.comParcels)"
                                        type="button"
                                        class="btn btn-sm"
                                        [ngClass]="
                                          c.parcelComplementaryJustificationId
                                            ? 'btn-outline-warning'
                                            : 'btn-outline-secondary'
                                        "
                                        (click)="
                                          openJustificationModalComParcel(c);
                                          $event.stopPropagation()
                                        "
                                        [matTooltip]="
                                          c.parcelComplementaryJustificationId
                                            ? 'Modifica giustificazione'
                                            : 'Aggiungi giustificazione'
                                        "
                                      >
                                        <i class="fas fa-file-alt"></i>
                                      </button>
                                    </td>
                                    <td>
                                      <button
                                        *ngIf="
                                          canSpecial() &&
                                          canUpdate() &&
                                          c.parcelComplementaryType ==
                                            'TRANSPORT'
                                        "
                                        class="btn btn-sm btn-outline-primary"
                                        (click)="
                                          openUpdateComParcelModal(c);
                                          $event.stopPropagation()
                                        "
                                      >
                                        <i class="fas fa-pencil-alt"></i>
                                      </button>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </ng-container>
                        </div>
                      </div>

                      <!-- TAB MAPPA -->
                      <div
                        class="tab-pane fade"
                        [class.show]="p.activeTab === 'map'"
                        [class.active]="p.activeTab === 'map'"
                      >
                        <div *ngIf="p.dealerLatitude && p.dealerLongitude">
                          <!-- MAPPA -->
                          <app-parcel-map
                            [dealerLat]="p.dealerLatitude"
                            [dealerLng]="p.dealerLongitude"
                            [parcelLat]="p.parcelLatitude"
                            [parcelLng]="p.parcelLongitude"
                            [parcelCode]="p.parcelCode"
                            [dealerName]="p.dealerName"
                            [parcelBrandCode]="p.parcelBrandCode"
                            [maximumRange]="p.parcelWaybillMaximumRange"
                          >
                          </app-parcel-map>
                        </div>

                        <!-- INFO DISTANZA / RANGE -->
                        <ng-container
                          *ngIf="
                            p.dealerLatitude &&
                              p.dealerLongitude &&
                              p.parcelLatitude &&
                              p.parcelLongitude;
                            else noCoordsTpl
                          "
                        >
                          <div
                            class="alert mt-3 mb-0"
                            [ngClass]="
                              p.coordinatesInRange === 'IN_RANGE'
                                ? 'alert-success'
                                : 'alert-warning'
                            "
                          >
                            <div class="d-flex align-items-start">
                              <i
                                class="me-2 mt-1"
                                [ngClass]="
                                  p.coordinatesInRange === 'IN_RANGE'
                                    ? 'fas fa-check-circle'
                                    : 'fas fa-exclamation-triangle'
                                "
                              ></i>
                              <div>
                                <strong
                                  *ngIf="p.coordinatesInRange === 'IN_RANGE'"
                                >
                                  Consegna nel raggio di
                                  {{ p.parcelWaybillMaximumRange }}m dalla
                                  destinazione.
                                </strong>
                                <strong
                                  *ngIf="p.coordinatesInRange !== 'IN_RANGE'"
                                >
                                  Consegna fuori dal raggio di
                                  {{ p.parcelWaybillMaximumRange }}m dalla
                                  destinazione.
                                </strong>
                                <br />
                                <span *ngIf="p.distanceInMeters != null">
                                  Distanza:
                                  {{ p.distanceInMeters | number: "1.0-0" }}m
                                  dalla destinazione.
                                </span>
                              </div>
                            </div>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                    <!-- SOLO MAPPA (quando canSpecial() è false, quindi niente tab) -->
                    <ng-template #mapOnlyTpl>
                      <div *ngIf="p.dealerLatitude && p.dealerLongitude">
                        <app-parcel-map
                          [dealerLat]="p.dealerLatitude"
                          [dealerLng]="p.dealerLongitude"
                          [parcelLat]="p.parcelLatitude"
                          [parcelLng]="p.parcelLongitude"
                          [parcelCode]="p.parcelCode"
                          [dealerName]="p.dealerName"
                          [parcelBrandCode]="p.parcelBrandCode"
                          [maximumRange]="p.parcelWaybillMaximumRange"
                        >
                        </app-parcel-map>
                      </div>

                      <ng-container
                        *ngIf="
                          p.dealerLatitude &&
                            p.dealerLongitude &&
                            p.parcelLatitude &&
                            p.parcelLongitude;
                          else noCoordsTpl
                        "
                      >
                        <div
                          class="alert mt-3 mb-0"
                          [ngClass]="
                            p.coordinatesInRange === 'IN_RANGE'
                              ? 'alert-success'
                              : 'alert-warning'
                          "
                        >
                          <div class="d-flex align-items-start">
                            <i
                              class="me-2 mt-1"
                              [ngClass]="
                                p.coordinatesInRange === 'IN_RANGE'
                                  ? 'fas fa-check-circle'
                                  : 'fas fa-exclamation-triangle'
                              "
                            ></i>
                            <div>
                              <strong
                                *ngIf="p.coordinatesInRange === 'IN_RANGE'"
                              >
                                Consegna nel raggio di
                                {{ p.parcelWaybillMaximumRange }}m dalla
                                destinazione.
                              </strong>
                              <strong
                                *ngIf="p.coordinatesInRange !== 'IN_RANGE'"
                              >
                                Consegna fuori dal raggio di
                                {{ p.parcelWaybillMaximumRange }}m dalla
                                destinazione.
                              </strong>
                              <br />
                              <span *ngIf="p.distanceInMeters != null">
                                Distanza:
                                {{ p.distanceInMeters | number: "1.0-0" }}m
                                dalla destinazione.
                              </span>
                            </div>
                          </div>
                        </div>
                      </ng-container>
                    </ng-template>

                    <ng-template #noCoordsTpl>
                      <div class="alert alert-info mt-3 mb-0">
                        Coordinate di consegna non disponibili per questo collo.
                      </div>
                    </ng-template>
                  </div>
                </div>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>
  <div
    *ngIf="!isLoading && !dateError && searchCompleted && parcels.length === 0"
    class="mx-3"
  >
    <div
      class="alert alert-warning d-flex align-items-center justify-content-between"
    >
      <div>
        <i class="fas fa-exclamation-triangle me-2"></i>
        <span>Nessun collo trovato con i filtri applicati.</span>
      </div>
      <!--tolto perché non applicava i filtri sopra -->
      <!-- <button class="action-btn primary" (click)="loadData()">
            <i class="fa fa-refresh me-1"></i>
            <span class="action-text">Riprova</span>
          </button> -->
    </div>
  </div>

  <!-- Pagination -->
  <pagination-controls
    *ngIf="totalRecords > 0"
    id="parcel-pagination"
    [maxSize]="5"
    [autoHide]="true"
    [responsive]="true"
    previousLabel="←"
    nextLabel="→"
    class="d-flex justify-content-end mt-3"
    (pageChange)="onPageChange($event)"
  >
  </pagination-controls>
</div>

<!-- Loader centrato -->
<div *ngIf="isLoading" class="loading-overlay">
  <div
    class="spinner-border text-primary"
    role="status"
    style="width: 4rem; height: 4rem"
  >
    <span class="visually-hidden">Caricamento...</span>
  </div>
</div>

<div
  *ngIf="showNotification"
  class="alert alert-warning d-flex align-items-center justify-content-between"
  style="
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 300px;
    z-index: 1050;
  "
>
  <div>
    <i class="fas fa-exclamation-triangle me-2"></i>
    <span>{{ notificationMessage }}</span>
  </div>
</div>

<!-- Modal di dettaglio della modifica fatta -->
<div
  class="modal fade show"
  tabindex="-1"
  [ngClass]="{ 'd-block': showModalDetailModifies }"
  style="background-color: rgba(0, 0, 0, 0.5)"
  *ngIf="showModalDetailModifies"
>
  <div class="modal-dialog modal-data-modifica modal-dialog-centered modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          <b
            >Collo {{ selectedParcel?.parcelCode }}: dati originali e modificati
          </b>
        </h5>
      </div>
      <div class="modal-body">
        <!-- Sezione DATE -->
        <h6 class="mb-3">
          <i class="fa-solid fa-calendar-days"></i> Date di consegna
        </h6>
        <div class="table-responsive">
          <table class="table table-bordered align-middle text-center">
            <thead class="table-light">
              <tr>
                <th>Originale PTV</th>
                <th>Inviata</th>
                <th>Stimata</th>
                <th>Stato</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  {{
                    selectedParcel?.parcelOriginalDeliveryDate
                      | date: "dd/MM/yyyy HH:mm" || "—"
                  }}
                </td>
                <td>
                  {{
                    selectedParcel?.parcelDeliveryDate
                      | date: "dd/MM/yyyy HH:mm" || "—"
                  }}
                </td>
                <td>
                  {{
                    selectedParcel?.parcelEstimatedDeliveryDate
                      | date: "dd/MM/yyyy HH:mm" || "—"
                  }}
                </td>
                <td>
                  <ng-container
                    *ngIf="selectedParcel?.parcelDeliveryDateIsForced === 'Y'"
                  >
                    <i
                      *ngIf="
                        selectedParcel?.parcelDeliveryDateIsUpdated === 'Y'
                      "
                      class="bi bi-pencil-fill text-primary"
                    >
                      Modificata</i
                    >
                    <i
                      *ngIf="
                        selectedParcel?.parcelDeliveryDateIsUpdated !== 'Y'
                      "
                      class="bi bi-plus-circle-fill text-primary"
                    >
                      Aggiunta</i
                    >
                  </ng-container>
                  <ng-container
                    *ngIf="selectedParcel?.parcelDeliveryDateIsForced !== 'Y'"
                  >
                    <span class="text-muted">Nessuna modifica</span>
                  </ng-container>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Sezione COORDINATE -->
        <h6 class="mt-4 mb-3">
          <i class="fa-solid fa-map-pin"></i> Coordinate di consegna
        </h6>
        <div class="table-responsive">
          <table class="table table-bordered align-middle text-center">
            <thead class="table-light">
              <tr>
                <th>Latitudine originale PTV</th>
                <th>Longitudine originale PTV</th>
                <th>Latitudine inviata</th>
                <th>Longitudine inviata</th>
                <th>Stato</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  {{
                    selectedParcel?.parcelOriginalLatitude !== null
                      ? selectedParcel?.parcelOriginalLatitude
                      : "—"
                  }}
                </td>
                <td>
                  {{
                    selectedParcel?.parcelOriginalLongitude !== null
                      ? selectedParcel?.parcelOriginalLongitude
                      : "—"
                  }}
                </td>
                <td>
                  {{
                    selectedParcel?.parcelLatitude !== null
                      ? selectedParcel?.parcelLatitude
                      : "—"
                  }}
                </td>
                <td>
                  {{
                    selectedParcel?.parcelLongitude !== null
                      ? selectedParcel?.parcelLongitude
                      : "—"
                  }}
                </td>
                <td>
                  <ng-container
                    *ngIf="
                      selectedParcel?.parcelDeliveryCoordinatesIsForced === 'Y'
                    "
                  >
                    <i
                      *ngIf="
                        selectedParcel?.parcelDeliveryCoordinatesIsUpdated ===
                        'Y'
                      "
                      class="bi bi-pencil-fill text-primary"
                    >
                      Modificata</i
                    >
                    <i
                      *ngIf="
                        selectedParcel?.parcelDeliveryCoordinatesIsUpdated !==
                        'Y'
                      "
                      class="bi bi-plus-circle-fill text-primary"
                    >
                      Aggiunta</i
                    >
                  </ng-container>
                  <ng-container
                    *ngIf="
                      selectedParcel?.parcelDeliveryCoordinatesIsForced !== 'Y'
                    "
                  >
                    <span class="text-muted">Nessuna modifica</span>
                  </ng-container>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-light" (click)="closeModalDetailModifies()">
          Chiudi
        </button>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade"
  tabindex="-1"
  style="background-color: rgba(0, 0, 0, 0.5)"
  [ngClass]="{ 'show d-block': showJustificationModal }"
  role="dialog"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          Giustificazione collo - {{ selectedParcel?.parcelCode }} ({{
            selectedParcel?.parcelWaybillCode
          }})
          <span *ngIf="isJustificationSent" class="text-success ms-3 fw-bold">
            <i class="fas fa-check-circle me-1"></i>
            SENT
          </span>
        </h5>
      </div>

      <!-- <div class="modal-body">
                <label class="form-label">Giustificativo</label>
                <select class="form-select" [(ngModel)]="editFormJustification.parcelJustificationId">
                    <option value="">Nessuno</option>
                    <option *ngFor="let justification of filteredJustifications"
                            [value]="justification.justificationId">
                        {{ justification.justificationName }}
                    </option>
                </select>

                <label class="form-label mt-2">Commento giustificativo</label>
                <textarea class="form-control"
                          [(ngModel)]="editFormJustification.parcelJustificationComment"
                          name="parcelJustificationComment"
                          rows="3">
                </textarea>
            </div> -->

      <div class="modal-body">
        <label class="form-label">Giustificativo</label>

        <div class="dropdown custom-justifications-dropdown">
          <button
            class="btn w-100 text-start custom-dropdown-btn"
            type="button"
            [disabled]="isJustificationSent"
            (click)="!isJustificationSent && toggleJustificationsDropdown()"
          >
            <div class="d-flex align-items-center">
              <i class="fas fa-file-alt me-2"></i>

              <div class="flex-grow-1">
                <ng-container *ngIf="!getSelectedJustificationName()">
                  Seleziona giustificativo
                </ng-container>

                <ng-container *ngIf="getSelectedJustificationName()">
                  <div class="fw-bold">
                    {{ getSelectedJustificationName() }}
                  </div>
                  <div class="small text-muted">Giustificativo selezionato</div>
                </ng-container>
              </div>

              <i class="fas fa-chevron-down dropdown-arrow"></i>
            </div>
          </button>

          <ul
            class="dropdown-menu w-100 custom-carrier-menu"
            [class.show]="isJustificationsDropdownOpen"
          >
            <!-- Ricerca -->
            <li
              class="dropdown-search-container"
              (click)="$event.stopPropagation()"
            >
              <div class="position-relative d-flex">
                <input
                  type="text"
                  class="form-control search-input"
                  placeholder="Cerca giustificativo..."
                  [(ngModel)]="justificationSearchTerm"
                  (click)="$event.stopPropagation()"
                  [ngModelOptions]="{ standalone: true }"
                />

                <button
                  *ngIf="justificationSearchTerm"
                  class="btn btn-sm clear-search-btn"
                  type="button"
                  (click)="clearJustificationSearch(); $event.stopPropagation()"
                >
                  <i class="fas fa-times"></i>
                </button>
              </div>
            </li>

            <li class="dropdown-divider"></li>

            <!-- Nessun risultato -->
            <li
              *ngIf="getFilteredJustifications().length === 0"
              class="dropdown-item disabled p-3"
            >
              <div class="text-center text-muted">
                <i class="fas fa-search mb-2"></i>
                <div>Nessun giustificativo trovato</div>
              </div>
            </li>

            <!-- Opzione nessuno -->
            <li
              class="dropdown-item d-flex align-items-center p-3 cursor-pointer"
              [class.disabled]="isJustificationSent"
              (click)="!isJustificationSent && selectJustification(null)"
              (click)="selectJustification(null)"
            >
              <div class="d-flex align-items-center w-100">
                <i class="fas fa-times me-3 text-muted"></i>
                <div class="flex-grow-1">Nessuno</div>
              </div>
            </li>

            <!-- Lista -->
            <div class="dropdown-items-container">
              <li
                *ngFor="let justification of getFilteredJustifications()"
                class="dropdown-item d-flex align-items-center p-3 cursor-pointer"
                [ngClass]="{
                  selected:
                    editFormJustification.parcelJustificationId ===
                    justification.justificationId,
                  disabled: isJustificationSent,
                }"
                (click)="
                  !isJustificationSent && selectJustification(justification)
                "
              >
                <div class="d-flex align-items-center w-100">
                  <i
                    class="fas fa-file-alt me-3"
                    [ngClass]="{
                      'text-primary':
                        editFormJustification.parcelJustificationId ===
                        justification.justificationId,
                      'text-muted':
                        editFormJustification.parcelJustificationId !==
                        justification.justificationId,
                    }"
                  >
                  </i>

                  <div class="flex-grow-1 min-w-0">
                    <div
                      class="text-truncate"
                      [ngClass]="{
                        'text-primary':
                          editFormJustification.parcelJustificationId ===
                          justification.justificationId,
                        'fw-bold':
                          editFormJustification.parcelJustificationId ===
                          justification.justificationId,
                      }"
                    >
                      {{ justification.justificationName }}
                    </div>
                  </div>
                </div>
              </li>
            </div>
          </ul>
        </div>

        <label class="form-label mt-3">Commento giustificativo</label>

        <textarea
          class="form-control"
          [disabled]="isJustificationSent"
          [(ngModel)]="editFormJustification.parcelJustificationComment"
          name="parcelJustificationComment"
          rows="3"
        >
        </textarea>
      </div>

      <div class="modal-footer d-flex justify-content-between">
        <button class="btn btn-light" (click)="closeJustificationModal()">
          Annulla
        </button>
        <div>
          <button
            class="btn btn-primary me-2"
            (click)="saveJustification(false)"
          >
            Salva per collo
          </button>
          <button class="btn btn-warning" (click)="saveJustification(true)">
            Salva per bolla<ng-container
              *ngIf="numberParcelsOfWaybill !== null"
            >
              ({{ numberParcelsOfWaybill }} colli)</ng-container
            >
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade"
  tabindex="-1"
  style="background-color: rgba(0, 0, 0, 0.5)"
  [ngClass]="{ 'show d-block': showJustificationModalComParcel }"
  role="dialog"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          Giustificazione evento del collo -
          {{ selectedComParcel?.parcelComplementaryCode }} ({{
            selectedComParcel?.parcelComplementaryWaybillCode
          }})
        </h5>
      </div>

      <div class="modal-body">
        <label class="form-label">Giustificativo</label>
        <select
          class="form-select"
          [(ngModel)]="
            editFormJustificationComParcel.parcelComplementaryJustificationId
          "
        >
          <option value="">Nessuno</option>
          <option
            *ngFor="let justification of filteredJustifications"
            [value]="justification.justificationId"
          >
            {{ justification.justificationName }}
          </option>
        </select>

        <label class="form-label mt-2">Commento giustificativo</label>
        <textarea
          class="form-control"
          [(ngModel)]="
            editFormJustificationComParcel.parcelComplementaryJustificationComment
          "
          name="parcelComplementaryJustificationComment"
          rows="3"
        >
        </textarea>
      </div>

      <div class="modal-footer d-flex justify-content-between">
        <button
          class="btn btn-light"
          (click)="closeJustificationModalComParcel()"
        >
          Annulla
        </button>
        <div>
          <button
            class="btn btn-primary me-2"
            (click)="saveJustificationComParcel(false)"
          >
            Salva singolo evento
          </button>
          <button
            disabled
            class="btn btn-warning"
            (click)="saveJustificationComParcel(true)"
          >
            Salva anche per successivi
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade"
  tabindex="-1"
  style="background-color: rgba(0, 0, 0, 0.5)"
  [ngClass]="{ 'show d-block': showUpdateComParcelModal }"
  role="dialog"
>
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          Aggiorna vettore per tratta ({{
            selectedComParcel?.parcelComplementaryCode
          }}
          - {{ selectedComParcel?.parcelComplementaryWaybillCode }})
        </h5>
      </div>

      <div class="modal-body">
        <div class="row mb-3">
          <div class="col-md-6">
            <label class="form-label">Da</label>
            <input
              type="text"
              class="form-control"
              [value]="
                getWarehouseNameComParcel(
                  selectedComParcel?.parcelComplementaryWarehouseFrom
                ) ||
                getDealerName(selectedComParcel?.parcelComplementaryDealerFrom)
              "
              disabled
            />
          </div>

          <div class="col-md-6">
            <label class="form-label">A</label>
            <input
              type="text"
              class="form-control"
              [value]="
                getWarehouseNameComParcel(
                  selectedComParcel?.parcelComplementaryWarehouseTo
                ) ||
                getDealerName(selectedComParcel?.parcelComplementaryDealerTo)
              "
              disabled
            />
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-md-6">
            <label class="form-label">Data inizio evento</label>
            <input
              type="text"
              class="form-control"
              [value]="
                selectedComParcel?.parcelComplementaryEventStart
                  ? (selectedComParcel?.parcelComplementaryEventStart
                    | date: 'dd/MM/yyyy HH:mm')
                  : ''
              "
              disabled
            />
          </div>
          <div class="col-md-6">
            <label class="form-label">Data fine evento</label>
            <input
              type="text"
              class="form-control"
              [value]="
                selectedComParcel?.parcelComplementaryEventEnd
                  ? (selectedComParcel?.parcelComplementaryEventEnd
                    | date: 'dd/MM/yyyy HH:mm')
                  : ''
              "
              disabled
            />
          </div>
        </div>

        <div class="row mb-4">
          <div class="col-md-12">
            <label class="form-label">Vettore</label>
            <select
              class="form-select"
              [(ngModel)]="
                editFormUpdateComParcel.parcelComplementaryCarrierCode
              "
            >
              <option
                *ngFor="let carrier of allCarriers"
                [value]="carrier.carrierCode"
              >
                {{ carrier.carrierName }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <div class="modal-footer d-flex justify-content-between">
        <button class="btn btn-light" (click)="closeUpdateComParcelModal()">
          Annulla
        </button>
        <div>
          <button class="btn btn-primary me-2" (click)="updateComParcel(false)">
            Salva per collo
          </button>
          <button class="btn btn-warning" (click)="updateComParcel(true)">
            Salva per bolla<ng-container
              *ngIf="numberParcelsOfWaybill !== null"
            >
              ({{ numberParcelsOfWaybill }} colli)</ng-container
            >
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade"
  tabindex="-1"
  style="background-color: rgba(0, 0, 0, 0.5)"
  [ngClass]="{ 'show d-block': showNoteModal }"
  role="dialog"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          Note collo - {{ selectedParcel?.parcelCode }} ({{
            selectedParcel?.parcelWaybillCode
          }})
        </h5>
      </div>

      <div class="modal-body">
        <label class="form-label">Note</label>
        <textarea
          class="form-control"
          [(ngModel)]="editFormNote.parcelNote"
          name="parcelNote"
          rows="3"
        >
        </textarea>
      </div>

      <div class="modal-footer d-flex justify-content-between">
        <button class="btn btn-light" (click)="closeNoteModal()">
          Annulla
        </button>
        <div>
          <button class="btn btn-primary me-2" (click)="saveNote(false)">
            Salva per collo
          </button>
          <button class="btn btn-warning" (click)="saveNote(true)">
            Salva per bolla<ng-container
              *ngIf="numberParcelsOfWaybill !== null"
            >
              ({{ numberParcelsOfWaybill }} colli)</ng-container
            >
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal Dettagli invio mail vettori -->
<div
  class="modal fade"
  tabindex="-1"
  style="background-color: rgba(0, 0, 0, 0.5)"
  [ngClass]="{ 'show d-block': showCarrierMailModal }"
  role="dialog"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          <i class="fas fa-envelope-open text-success me-2"></i>
          Invio mail vettori - {{ selectedParcel?.parcelCode }} ({{
            selectedParcel?.parcelWaybillCode
          }})
        </h5>
      </div>

      <div class="modal-body">
        <div class="carrier-mail-status">
          <i class="fas fa-check-circle"></i>
          <span>Mail inviata correttamente ai vettori</span>
        </div>

        <div class="carrier-mail-info-block">
          <div class="carrier-mail-info-label">
            <i class="fas fa-clock"></i> Data e ora invio
          </div>
          <div class="carrier-mail-info-value">
            {{
              formatCarrierSentDate(selectedParcel?.waybillCarriersSentDate) ||
                "Non disponibile"
            }}
          </div>
        </div>

        <div class="carrier-mail-info-block">
          <div class="carrier-mail-info-label">
            <i class="fas fa-users"></i> Destinatari ({{
              getCarrierSentEmailsList(
                selectedParcel?.waybillCarriersSentEmails
              ).length
            }})
          </div>
          <div class="carrier-mail-chips">
            <span
              class="carrier-mail-chip"
              *ngFor="
                let email of getCarrierSentEmailsList(
                  selectedParcel?.waybillCarriersSentEmails
                )
              "
            >
              <i class="fas fa-envelope"></i> {{ email }}
            </span>
            <span
              class="carrier-mail-chip-empty"
              *ngIf="
                getCarrierSentEmailsList(
                  selectedParcel?.waybillCarriersSentEmails
                ).length === 0
              "
            >
              Nessun destinatario disponibile
            </span>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button class="btn btn-light" (click)="closeCarrierMailModal()">
          Chiudi
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Modal Import Excel -->
<div
  class="modal fade show"
  tabindex="-1"
  [ngClass]="{ 'd-block': showImportExcelModal }"
  style="background-color: rgba(0, 0, 0, 0.5)"
  *ngIf="showImportExcelModal"
  (click)="closeImportExcelModal()"
>
  <div
    class="modal-dialog modal-md modal-dialog-centered"
    (click)="$event.stopPropagation()"
  >
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Importa Giustifiche da Excel</h5>
      </div>

      <div class="modal-body">
        <div class="import-justifications-format mb-3">
          <p class="mb-2">
            Parti dal modello: la <strong>prima riga</strong> contiene le
            intestazioni delle colonne e, dalla seconda, ogni riga è un collo.
            Viene letto solo il primo foglio del file.
          </p>
          <p class="mb-1">Colonne del file:</p>
          <ul class="mb-2">
            <li><strong>Codice collo</strong>: obbligatorio.</li>
            <li>
              <strong>Codice giustifica</strong>: obbligatorio. Deve essere uno
              dei codici utilizzabili per il cliente del collo (vedi l'elenco
              qui sotto).
            </li>
            <li>
              <strong>Commento giustifica</strong>: facoltativo, al massimo 255
              caratteri (le lettere accentate contano come due). Se lo lasci
              vuoto, il collo mantiene il commento che ha già.
            </li>
          </ul>
          <p class="mb-0 text-muted small">
            Se anche una sola riga contiene un errore, l'import viene annullato
            e nessun collo viene aggiornato. Il messaggio di errore indica cosa
            correggere.
          </p>
        </div>

        <button
          class="btn btn-outline-secondary w-100 mb-3"
          [disabled]="isLoadingJustificationCodes"
          (click)="downloadImportJustificationsTemplate()"
        >
          <i class="fas fa-download me-1"></i>
          Scarica modello
        </button>

        <div
          *ngIf="isLoadingJustificationCodes"
          class="text-muted small mb-3"
        >
          <span
            class="spinner-border spinner-border-sm me-1"
            role="status"
          ></span>
          Caricamento dei codici giustifica...
        </div>

        <details
          *ngIf="importJustificationCodeGroups.length > 0"
          class="import-justifications-codes mb-3"
        >
          <summary>Codici giustifica utilizzabili</summary>
          <div *ngFor="let group of importJustificationCodeGroups" class="mt-2">
            <div class="fw-bold small">{{ group.title }}</div>
            <table class="table table-sm mb-0">
              <tbody>
                <tr *ngFor="let c of group.codes">
                  <td class="import-justifications-code">{{ c.code }}</td>
                  <td>{{ c.name }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </details>

        <div class="mb-3">
          <input
            type="file"
            #fileInput
            hidden
            accept=".xlsx,.xls"
            (change)="onFileSelected($event)"
          />

          <button class="btn btn-primary w-100" (click)="fileInput.click()">
            Seleziona file dal tuo PC
          </button>
        </div>

        <div *ngIf="selectedExcelFile" class="alert alert-light">
          File selezionato:
          <strong>{{ selectedExcelFile.name }}</strong>
        </div>
      </div>

      <div class="modal-footer">
        <button class="btn btn-light" (click)="closeImportExcelModal()">
          Chiudi
        </button>

        <button
          class="btn btn-primary"
          [disabled]="!selectedExcelFile"
          (click)="importExcelJustifications()"
        >
          Importa Giustifiche
        </button>
      </div>
    </div>
  </div>
</div>
